import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CustomChart1Component } from './custom-chart1/custom-chart1.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import {GeniusSettingsComponent} from './genius-settings/genius-settings.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MaterialModule} from '../material/material.module';
import { InfoDialogComponent } from './info-dialog/info-dialog/info-dialog.component';
import {CoreModule} from '../core/core.module';
import {TourMatMenuModule} from 'ngx-ui-tour-md-menu';
import { ElectrodeContactDialogComponent } from './electrode-contact-dialog/electrode-contact-dialog.component';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';
import {PickerModule} from '@ctrl/ngx-emoji-mart';
import { FilePreviewComponent } from './chat-widget/file-preview/file-preview.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {ChatUsersSortPipe} from '../pipes/chat-users-sort.pipe';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import { BindSensorComponent } from './genius-settings/bind-sensor/bind-sensor.component';
import {DeviceIdPipe} from '../pipes/device-id.pipe';
import { DeleteConfirmationDialogComponent } from './delete-confirmation-dialog/delete-confirmation-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { AddTextAnswerDialogComponent } from './chat-widget/add-text-answer-dialog/add-text-answer-dialog.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { VersionWarningComponent } from './version-warning/version-warning.component';
import { SignalUnstableComponent } from './genius-settings/signal-unstable/signal-unstable.component';
import { SubscriptionsErrorComponent } from './genius-settings/subscriptions-error/subscriptions-error.component';
import { DeleteCommentComponent } from './comments-modal/delete-comment/delete-comment.component';
import { ChangelogDialogComponent } from './changelog-dialog/changelog-dialog.component';
import { LicenseModalComponent } from './license-modal/license-modal.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { SafariBrowserWarningComponent } from './safari-browser-warning/safari-browser-warning.component';
import { DeviceCareModalComponent } from './genius-settings/device-care-modal/device-care-modal.component';
import { TrainingIntroDialogComponent } from './training-intro-dialog/training-intro-dialog.component';
import {
  VisibilityButtonsTutorialDialogComponent
} from './visibility-buttons-tutorial-dialog/visibility-buttons-tutorial-dialog.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [CustomChart1Component, GeniusSettingsComponent, InfoDialogComponent, ElectrodeContactDialogComponent, ChatWidgetComponent, FilePreviewComponent, ChatUsersSortPipe, BindSensorComponent, DeviceIdPipe, DeleteConfirmationDialogComponent, PieChartComponent, AddTextAnswerDialogComponent, VersionWarningComponent, SignalUnstableComponent, SubscriptionsErrorComponent, DeleteCommentComponent, ChangelogDialogComponent, LicenseModalComponent, ConfirmModalComponent, SafariBrowserWarningComponent, DeviceCareModalComponent, TrainingIntroDialogComponent, VisibilityButtonsTutorialDialogComponent],
  imports: [
    CommonModule,
    NgxChartsModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MaterialModule,
    CoreModule,
    TourMatMenuModule,
    PickerModule,
    PdfViewerModule,
    NgbTooltipModule,
    MatDialogModule,
    MatExpansionModule,
    FormsModule
  ],
  exports: [
    GeniusSettingsComponent, InfoDialogComponent, ChatWidgetComponent, BindSensorComponent, DeviceIdPipe, PieChartComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [InfoDialogComponent, FilePreviewComponent, BindSensorComponent,DeleteConfirmationDialogComponent,AddTextAnswerDialogComponent, VersionWarningComponent, SignalUnstableComponent, SubscriptionsErrorComponent, DeleteCommentComponent, LicenseModalComponent, ConfirmModalComponent, SafariBrowserWarningComponent, DeviceCareModalComponent, TrainingIntroDialogComponent, VisibilityButtonsTutorialDialogComponent]
})
export class ComponentsModule { }
